/* eslint-disable global-require */
module.exports = {};
